import React from "react";
import ProfileCard from "./ProfileCard";
import Disclaimer from "./Disclaimer";
import profilesData from "../data/profiles.json";

interface Profile {
  id: string;
  type: string;
  title: string;
  shortDescription: string;
  longDescription: string;
  image: string;
  youtubeVideoId?: string;
  gumroadLink: string;
}
interface ProfileListingPageLayoutProps {
  pageTitle: string;
  pageDescription: React.ReactNode;
  profileTypeFilter: string;
  titleGradientClass?: string;
  excludeIds?: string[];
}

const ProfileListingPageLayout: React.FC<ProfileListingPageLayoutProps> = ({
  pageTitle,
  pageDescription,
  profileTypeFilter,
  titleGradientClass = "",
  excludeIds = [],
}) => {
  const filteredProfiles = profilesData.filter(
    (profile) =>
      profile.type === profileTypeFilter && !excludeIds.includes(profile.id),
  );

  return (
    <div className="container mx-auto p-8 text-white max-w-[1280px]">
      <section className="py-5 text-center">
        <h1
          className={`text-4xl md:text-6xl lg:text-8xl font-bold mb-0 lg:mb-20 ${titleGradientClass}`}
        >
          {pageTitle}
        </h1>
        {pageDescription}
      </section>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
        {filteredProfiles.map((profile: Profile) => (
          <ProfileCard key={profile.id} profile={profile} />
        ))}
      </div>
      <Disclaimer />{" "}
    </div>
  );
};

export default ProfileListingPageLayout;
